module.exports = __webpack_public_path__ + "static/media/pc.2adde5aa.png";